import { takeEvery } from 'redux-saga/effects';
import { Action } from 'redux-actions';
import sagaUtility from '../../blocks/utils/saga-utility';
import { GetTicketTransactionsRequest } from '../../models/ticket/GetTicketTransactionsRequest';
import TicketService from '../../services/ticket.service';
import { GetLatestTicketTransactionsActionTypes, GetTicketTransactionsActionTypes } from './types';
import { getLatestTicketTransactionsActions, getTicketTransactionsActions } from './actions';

export default function* ticketSaga() {
    yield takeEvery(GetTicketTransactionsActionTypes.REQUEST, getTicketTransactionsRequest);
    yield takeEvery(GetLatestTicketTransactionsActionTypes.REQUEST, getLatestTicketTransactionsRequest);
}

function* getTicketTransactionsRequest(action: Action<GetTicketTransactionsRequest>) {
    yield sagaUtility(action.payload, TicketService.getTicketTransactions, getTicketTransactionsActions.success, getTicketTransactionsActions.failure);
}

function* getLatestTicketTransactionsRequest(action: Action<any>) {
    yield sagaUtility(action.payload, TicketService.getLatestTicketTransactions, getLatestTicketTransactionsActions.success, getLatestTicketTransactionsActions.failure);
}
